import APIUtils from '@spothero/utils/api';

const VehicleAPI = {
    add(requestData, userId) {
        return APIUtils.post(`/users/${userId}/vehicles/`, requestData, {
            headers: {'SpotHero-Version': '2019-08-22'},
        });
    },

    getVehicleInfos(search) {
        return APIUtils.get('vehicle-types/', {
            search,
        });
    },

    getOversizedFee({make, model, year}) {
        return APIUtils.get('vehicle-types/oversized-fee/', {
            make,
            model,
            year,
        });
    },

    getColorOptions() {
        return APIUtils.get('vehicle-colors/');
    },
};

export default VehicleAPI;
